import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import * as _ from 'lodash-es';
import { debounceTime } from 'rxjs/operators';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { AutoCompleteValidators } from 'src/app/shared/validators/auto-complete-validators';
import { IChildProject } from 'src/app/models/projects/project.model';
import { Query, ResolverService } from 'src/app/services/api/resolver.service';
import { SelectDialog, SelectDialogOptions } from '../select-dialog/select-dialog.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { AutocompleteFilterComponent } from '../../autocomplete-filter/autocomplete-filter.component';
import { MatButton } from '@angular/material/button';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';



export interface ServiceSelectDialogOptions extends SelectDialogOptions {
    query: Query;
    service: ResolverService<any>,
}

@Component({
    selector: 'app-service-select-dialog',
    templateUrl: './service-select-dialog.component.html',
    styleUrls: ['./service-select-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatDialogTitle, FormsModule, ReactiveFormsModule, RxReactiveFormsModule, AutocompleteFilterComponent, MatDialogActions, MatButton, MatDialogClose, UpperCasePipe, TranslatePipe]
})
export class ServiceSelectDialog extends SelectDialog implements OnInit {
    config: ServiceSelectDialogOptions;


    query: Query;
    service: ResolverService<any>;

    loading: boolean = false;

    constructor() {
        const config = inject<ServiceSelectDialogOptions>(MAT_DIALOG_DATA);

        super();
        this.config = config;


        // INIT FROM OPTIONS
        this.query = config.query || {};
        this.service = config.service;
    }


    async ngOnInit(): Promise<void> {
        await super.ngOnInit();
        //Retriving
        this._data = await this.retrieve();
        this.controls['data'].addValidators(AutoCompleteValidators.mustBeInList(this.data, '_id', true));
        this.subscription.add(this.form.controls['data'].valueChanges.pipe(debounceTime(600)).subscribe(async (value: string) => {
            if (value && _.isString(value)) {
                this._data = await this.retrieve(value);
            }
        }));
    }

    async retrieve(search?: string) {
        this.loading = true;
        const query = search && !_.isEmpty(search.trim()) ? { __search: search.trim(), ...this.query } : this.query;
        const entities = await this.service.find(query, { $triggerEntityList: false });
        this.loading = false;
        return entities ? entities.map(this.map.bind(this)).filter((v: IChildProject) => { return this.predicate(v); }) : [];
    }
}